import { z } from 'zod'
import { oc } from '@orpc/contract'
import { mergeStatusSchema } from './patient-merge-shared.contract'

/**
 * Starting a merge, following it, and finding the kept record after one (PD-1986). Plain fields at
 * the boundary — never FHIR resources.
 */

export const patientMerge = oc
  .route({ method: 'POST', path: '/v2/patient-merge/merges' })
  .input(
    z.object({
      reviewId: z.string().min(1),
      /** The record that survives as it is; the other one is retired, with its records. */
      keepPatientId: z.string().min(1),
      /** Required when the indicators conflict or the recommended record is not the one kept. */
      reason: z.string().optional(),
      confirmedSamePerson: z.literal(true),
      confirmText: z.literal('Merge'),
    }),
  )
  .output(z.object({ mergeId: z.string() }))

export const patientMergeGet = oc
  .route({ method: 'GET', path: '/v2/patient-merge/merges/{mergeId}' })
  .input(z.object({ mergeId: z.string().min(1) }))
  .output(mergeStatusSchema)

export const patientMergeResume = oc
  .route({ method: 'POST', path: '/v2/patient-merge/merges/{mergeId}/resume' })
  .input(z.object({ mergeId: z.string().min(1) }))
  .output(mergeStatusSchema)

/** Where an old link to a merged (possibly already deleted) patient should lead. */
export const patientMergeRedirect = oc
  .route({ method: 'GET', path: '/v2/patient-merge/redirect/{patientId}' })
  .input(z.object({ patientId: z.string().min(1) }))
  .output(
    z.object({
      /** The record the patient was merged into; null when it was not merged away. */
      keptPatientId: z.string().nullable(),
      keptPatientName: z.string().optional(),
    }),
  )
